module.exports = __webpack_public_path__ + "img/yn-logo.891ffbcf.png";